import React from 'react';
import PropTypes from 'prop-types';
import TitleAutocompleteRow from './TitleAutocompleteRow';
import LoadableAutocomplete from 'treeline-react-core-components/LoadableAutocomplete';
import { cancelableDelay } from 'treeline-react-core-components/util';
import './titleAutocomplete.less';
import { Translate } from '@above-the-treeline/localization';
import { LoadingSpinnerSize } from '../UI/LoadingSpinner';
import LoadingWrapper from '../UI/LoadingWrapper';

export default class TitleAutocomplete extends React.Component {
	static propTypes = {
		children: PropTypes.element,
		onSelectOption: PropTypes.func,
		renderTitleOption: PropTypes.func,
		placeholder: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
		autoFocus: PropTypes.bool,
	};

	static defaultProps = {
		onSelectOption: () => {},
		placeholder: <Translate id="search_for_titles" />,
		renderTitleOption: product => {
			return <TitleAutocompleteRow product={product} />;
		},
		autoFocus: false,
	};

	state = {
		isLoading: false,
	};

	render() {
		return (
			<div className="title-autocomplete">
				<LoadingWrapper
					isLoading={this.state.isLoading}
					size={LoadingSpinnerSize.xssmall}>
					<LoadableAutocomplete
						optionIdName="sku"
						optionDisplayNameKey="name"
						placeholder={this.props.placeholder}
						canShowSuccess={false}
						onSelectHook={this.onSelectHook}
						hasSearchIcon={true}
						getURLForOptions={this.getURLForOptions}
						getOptionLabel={this.props.renderTitleOption}
						className={this.props.className}
						inputRequiredFeedback="Too short!"
						isClearable={false}
						width={325}
						autoFocus={this.props.autoFocus}
					/>
				</LoadingWrapper>
				{this.props.children}
			</div>
		);
	}

	componentWillUnmount() {
		if (this.delay && this.delay.cancel) {
			this.delay.cancel();
		}
	}

	getURLForOptions = userInput => {
		const base = `${process.env.REACT_APP_API_URL}/api/products/`;
		const endpoint = `/search?q=${userInput}&attributes=product,images`;
		return `${base}${endpoint}`;
	};

	onSelectHook = autocompleteState => {
		const { selectedId: sku } = autocompleteState;
		this.setState({ isLoading: true });

		this.delay = cancelableDelay(500);

		this.delay.promise.then(() => {
			this.setState({ isLoading: false });
			this.props.onSelectOption(sku, autocompleteState);
		});
	};
}
